/**
 * @NOTE - Types in these files should map to the equivalent types in our `mem-client-desktop` project.
 */

/**
 * Matches a subset of the events defined in the Recall.ai Desktop SDK.
 * - https://docs.recall.ai/docs/desktop-sdk
 *
 * Note that `realtime-event` can match a variety of events which are "registered" by
 * our backend.
 *
 * For more info, see the `recall client` in our python backend code.
 */
export enum RecallEventKind {
  RealtimeEvent = "realtime-event",
  MeetingDetected = "meeting-detected",
  UploadProgress = "upload-progress",
  RecordingEnded = "recording-ended",
}

/**
 * Matches the permission kinds defined in the Recall.ai Desktop SDK.
 * - https://docs.recall.ai/docs/desktop-sdk
 */
export enum RecallPermissionKind {
  Accessibility = "accessibility",
  ScreenCapture = "screen-capture",
  Microphone = "microphone",
}

/**
 * Matches the statuses defined in the Recall.ai Desktop SDK.
 * - https://docs.recall.ai/docs/desktop-sdk
 */
export enum RecallPermissionStatus {
  Granted = "granted",
  NotRequested = "not_requested",
  Denied = "denied",
}

export type RecallPermissionMap = Partial<Record<RecallPermissionKind, RecallPermissionStatus>>;
